import { MRT_ColumnDef } from 'mantine-react-table'
import { Text, Tooltip, Avatar } from '@mantine/core'
import { PaymentParams } from 'app/models/payments-params'
import { ReactNode } from 'react'
// import getInitials from 'app/views/components/functions/getInitials'
import { PaymentTransactionType } from 'app/models/dropdown-options'
import getInitials from 'app/views/components/functions/getInitials'
import { StatusPill } from 'app/views/components/pill/status-pill'
import { formatDateToShow, formatNumberToCurrency, stringToDate } from 'app/utils/util-functions'
import CustomHoverCard from 'app/views/components/popover/custom-hover-card'
import IonIcon from '@reacticons/ionicons'

function TableHead({ header }: { header: string }) {
  return (
    <Text
      style={{
        fontFamily: 'Plus Jakarta Sans',
        fontSize: '1.5em',
      }}
    >
      {header}
    </Text>
  )
}

function TableRowText({ text }: { text: ReactNode }) {
  return (
    <Text
      style={{
        fontFamily: 'Plus Jakarta Sans',
        fontSize: '1.5em',
      }}
    >
      {text}
    </Text>
  )
}

export function paymentCols(
): MRT_ColumnDef<PaymentParams>[] {
  return [
    {
      size: 3,
      accessorKey: 'hasAlert',
      header: '',
      Cell: ({ cell, row }) => {
        const hasAlert = cell.getValue<boolean>();
        const alertText = row.original.alertText ?? ''
        return hasAlert ?
          (
            <CustomHoverCard
              cardTitle='Alert'
              position="left"
              targetComponent={
                <div>
                  <IonIcon size="large" name="alert-circle-sharp" style={{ color: "red" }} />
                </div>
              }
            >
              <Text className="hover-card-alert-text">
                {alertText}
              </Text>
            </CustomHoverCard>
          ) : null
      },
      enableSorting: false,
      enableColumnActions: false,
    },
    {
      size: 5,
      accessorKey: 'payment.facilityName',
      header: 'Facility Name',
      Header: <TableHead header={'Name'} />,
      Cell: ({ cell }) => (
        <TableRowText text={cell.getValue<string>()} />
      )
    },
    {
      size: 5,
      accessorKey: 'payment.borrowerName',
      header: 'Entity',
      Header: <TableHead header={'Borrower Name'} />,
      Cell: ({ cell }) => (
        <TableRowText text={cell.getValue<string>()} />
      )
    },
    {
      size: 5,
      accessorKey: 'status',
      header: 'Stage',
      Header: <TableHead header={'Stage'} />,
      Cell: ({ cell, row }: any) => (
        <StatusPill status={cell.getValue()} payment={row.original} />
      ),
    },
    {
      size: 5,
      accessorFn: row => {
        return PaymentTransactionType.find(p => p.value == row.payment.transactionType)?.label ?? '';
      },
      accessorKey: 'payment.transactionType',
      header: 'Transaction',
      Header: <TableHead header={'Transaction'} />,
      Cell: ({ row }) => {
        return (
          <TableRowText
            text={
              PaymentTransactionType.find(p => p.value == row.original.payment.transactionType)
                ?.label ?? ''
            }
          />
        )
      },
    },
    {
      size: 5,
      accessorKey: 'payment.currency',
      header: 'Currency',
      Header: <TableHead header={'Currency'} />,
      Cell: ({ row }) => <TableRowText text={row.original.payment.currency ?? 'USD'} />,
    },
    {
      size: 5,
      accessorKey: 'payment.amount',
      header: 'Amount',
      Header: <TableHead header={'Amount'} />,
      filterVariant: 'range',
      Cell: ({ cell, row }: any) => (
        <TableRowText
          text={formatNumberToCurrency(cell.getValue(), row.original.payment.currency ?? 'USD')}
        />
      ),
    },
    {
      size: 5,
      accessorKey: 'payment.effectiveDate',
      header: 'Effective Date',
      Header: <TableHead header={'Effective Date'} />,
      accessorFn: row => {
        return stringToDate(row.payment.effectiveDate);
      },
      mantineFilterTextInputProps: {
        placeholder: 'Date',
      },
      filterFn: 'lessThanOrEqualTo',
      filterVariant: 'date',
      sortingFn: 'datetime',
      Cell: ({ cell }) => (
        <Text fz="1.5em">{formatDateToShow(cell.getValue<Date>())}</Text>
      ),
    },
    {
      size: 5,
      accessorKey: 'payment.opsAdminName',
      header: 'User',
      Header: <TableHead header={'User'} />,
      Cell: ({ cell }) => (
        <Tooltip label={cell.getValue<string>()}>
          <Avatar radius="xl" color="cyan" size="lg">
            {getInitials(cell.getValue<string>()?.toString())}
          </Avatar>
        </Tooltip>
      )
    },
  ]
}
